import { Row } from '@tanstack/react-table';
import useFormatCurrency from 'hooks/useFormatCurrency';
import { PromoCode, PromoCodeType } from 'models/PromoCode';

interface AmountPercentageCellProps {
  row: Row<PromoCode>;
  getValue: () => number;
}

const AmountPercentageCell = ({ row, getValue }: AmountPercentageCellProps) => {
  const value = getValue();
  const formatCurrency = useFormatCurrency();

  return row.original.type === PromoCodeType.PERCENT
    ? `${row.original.value}%`
    : formatCurrency({
        value,
        currency: row.original.currency ?? 'USD',
      });
};

export default AmountPercentageCell;
